import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87fefe3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-export" }

import { ref } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { exportDataHandleList, querySatelliteTreeList } from '@/api'
import { CODE_ENUM, DATA_EXPORT_TYPE } from '@/common'
import { formatFormTime, downLoadFile, getDate } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const advancedRef = ref()

const formInline = ref({
  queryType: '',
  key: '',
  collectTime: [],
})

const shortcuts = [
  {
    text: '今天',
    value: getDate(1, 'D'),
  },
  {
    text: '最近一个月',
    value: getDate(1, 'M'),
  },
  {
    text: '最近三个月',
    value: getDate(3, 'M'),
  },
  {
    text: '最近半年',
    value: getDate(6, 'M'),
  },
  {
    text: '最近一年',
    value: getDate(12, 'M'),
  },
]

const dataTypeOps = [
  {
    label: '平台原始报文',
    value: DATA_EXPORT_TYPE.RECEIVE,
  },
  {
    label: '平台接收条数汇总/天',
    value: DATA_EXPORT_TYPE.RECEIVE_DAY,
  },
  {
    label: '终端发送原始日志',
    value: DATA_EXPORT_TYPE.SEND,
  },
  {
    label: '终端发送条数汇总/天',
    value: DATA_EXPORT_TYPE.SEND_DAY,
  },
  {
    label: '卫星载荷计数',
    value: DATA_EXPORT_TYPE.SATELLITE,
  },
  {
    label: '卫星载荷计数汇总/天',
    value: DATA_EXPORT_TYPE.SATELLITE_DAY,
  },
  {
    label: '最终汇总数据',
    value: DATA_EXPORT_TYPE.FINAL,
  },
]

const rules: any = {
  queryType: { required: true, message: '请选择' },
  // key: { required: true, message: '请选择' },
  collectTime: { required: true, message: '请选择' },
}

const before = async () => {
  return new Promise((reslove) => {
    advancedRef.value.formRef.validate((valid: boolean) => {
      reslove(valid)
    })
  })
}

const getMoTime = (collectTime: any) => {
  return {
    ...formatFormTime(collectTime, ['startTime', 'endTime']),
  }
}

const exportData = () => {
  advancedRef.value.fetchList()
}

const loading = ref(false)
const fetchList = async ({ data }) => {
  loading.value = true
  const { queryType, key, collectTime } = data
  const moTime = getMoTime(collectTime)

  const res: any = await exportDataHandleList({
    queryType,
    key,
    ...moTime,
  }).finally(() => {
    loading.value = false
  })
  if (res?.msg?.code === CODE_ENUM.SUCCESS) {
    downLoadFile(res)
  }
}

const satelliteList: any = ref([])
const querySatelliteList = async () => {
  const res: any = await querySatelliteTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    satelliteList.value = res.data || []
  }
}

querySatelliteList()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      before: before,
      rules: rules,
      onFetchList: fetchList,
      hideRequiredAsterisk: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "文件类型",
          prop: "queryType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.queryType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.queryType) = $event)),
              filterable: "",
              class: "ws_select",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataTypeOps, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "卫星",
          prop: "key"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.key,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.key) = $event)),
              class: "ws_select",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(satelliteList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.satelliteCode,
                    label: item.satelliteName + ' (' + item.satelliteCode + '）',
                    value: item.satelliteCode
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "时间",
          prop: "collectTime",
          class: "ws_time_range",
          clearable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: formInline.value.collectTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.collectTime) = $event)),
              "unlink-panels": "",
              type: "datetimerange",
              "range-separator": "-",
              shortcuts: shortcuts,
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              editable: false
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { "label-width": 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: exportData,
              type: "primary",
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("导出")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})